import { getProvider, getWeb3 } from ".";
import config from "../../config/config";

import MafiaSmuggleMarketAbi from "../../abis/MafiaSmuggleMarket.json";
import { ethers } from "ethers";

export const getMafiaSmuggleMarketContract = (provider = false) => {
  const web3 = provider ? getProvider() : getWeb3();
  const contractAddress = config.smuggleMarketAddress;
  const MafiaSmuggleMarketContract = new web3.eth.Contract(
    MafiaSmuggleMarketAbi,
    contractAddress
  );
  return MafiaSmuggleMarketContract;
};

export const getLaunchBlock = async () => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract();
  const launchBlock: number = await MafiaSmuggleMarketContract.methods
    .launchBlock()
    .call();
  return Number(launchBlock);
};

export const getUpdateInterval = async () => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract();
  const updateInterval: number = await MafiaSmuggleMarketContract.methods
    .updateInterval()
    .call();
  return Number(updateInterval);
};

export const getCityMarketPrice = async (cityId: number) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract();
  const cityMarketPrice: { boozePrices: number[]; narcsPrices: number[] } =
    await MafiaSmuggleMarketContract.methods.getCityMarketPrice(cityId).call();
  return [cityMarketPrice.boozePrices, cityMarketPrice.narcsPrices].map(
    (price) => price.map((p) => Number(ethers.utils.formatEther(p)))
  );
};

export const buyBooze = async (
  account: string,
  types: number[],
  signMsg: string,
  signature: string
) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract(true);
  const receipt = await MafiaSmuggleMarketContract.methods
    .buyBooze(types, JSON.stringify(signMsg), signature)
    .send({ from: account });

  return receipt.transactionHash;
};

export const sellBooze = async (
  account: string,
  itemIds: number[],
  signMsg: string,
  signature: string
) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract(true);
  const receipt = await MafiaSmuggleMarketContract.methods
    .sellBooze(itemIds, JSON.stringify(signMsg), signature)
    .send({ from: account });

  return receipt.transactionHash;
};

export const buyNarcs = async (
  account: string,
  types: number[],
  signMsg: string,
  signature: string
) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract(true);
  const receipt = await MafiaSmuggleMarketContract.methods
    .buyNarcs(types, JSON.stringify(signMsg), signature)
    .send({ from: account });

  return receipt.transactionHash;
};

export const sellNarcs = async (
  account: string,
  itemIds: number[],
  signMsg: string,
  signature: string
) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract(true);
  const receipt = await MafiaSmuggleMarketContract.methods
    .sellNarcs(itemIds, JSON.stringify(signMsg), signature)
    .send({ from: account });

  return receipt.transactionHash;
};

export const getBoozeSuccessRate = async (level: number) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract();
  const successRate: number = await MafiaSmuggleMarketContract.methods
    .getBoozeSuccessRate(level)
    .call();
  return successRate;
};

export const getNarcsSuccessRate = async (level: number) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract();
  const successRate: number = await MafiaSmuggleMarketContract.methods
    .getNarcsSuccessRate(level)
    .call();
  return successRate;
};

export const getNextBoozeTime = async (account: string) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract();
  const nextBoozeTime: number = await MafiaSmuggleMarketContract.methods
    .nextBoozeTime(account)
    .call();
  return Number(nextBoozeTime);
};

export const getNextNarcsTime = async (account: string) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract();
  const nextNarcsTime: number = await MafiaSmuggleMarketContract.methods
    .nextNarcsTime(account)
    .call();
  return Number(nextNarcsTime);
};

export const getAmountLimit = async (account: string) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract();
  const amountLimit: any = await MafiaSmuggleMarketContract.methods
    .getAmountLimit(account)
    .call({ from: account });

  return [amountLimit.boozeLimit, amountLimit.narcsLimit].map((price) =>
    Number(price)
  );
};

export const claimBoozeProfit = async (account: string, cityId: number) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract(true);
  const receipt = await MafiaSmuggleMarketContract.methods
    .claimBoozeProfit(cityId)
    .send({ from: account });

  return receipt.transactionHash;
};

export const claimNarcsProfit = async (account: string, cityId: number) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract(true);
  const receipt = await MafiaSmuggleMarketContract.methods
    .claimNarcsProfit(cityId)
    .send({ from: account });

  return receipt.transactionHash;
};

export const getBoozeTotalProfit = async (city: number) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract();
  const data = await MafiaSmuggleMarketContract.methods
    .cityBoozeProfit(city)
    .call();
  return Number(ethers.utils.formatEther(String(data)));
};

export const getNarcoTotalProfit = async (city: number) => {
  const MafiaSmuggleMarketContract = getMafiaSmuggleMarketContract();
  const data = await MafiaSmuggleMarketContract.methods
    .cityNarcsProfit(city)
    .call();
  return Number(ethers.utils.formatEther(String(data)));
};
